export enum UserRoleEnum {
    ADMIN = 1,
    VIEWER = 2,
    CUSTOMER_EXPERIENCE_AGENT = 7,
    WEATHER = 8
}

// Only use this for pages we are absolutely certain all roles will always be able to see (e.g. Dashboard and Settings)
export const allUserRoles = [
  UserRoleEnum.ADMIN,
  UserRoleEnum.VIEWER,
  UserRoleEnum.CUSTOMER_EXPERIENCE_AGENT,
  UserRoleEnum.WEATHER
];
